module.exports = __webpack_public_path__ + "img/3d-elements-2.jpg";